import firebase from 'firebase/compat/app';

/**
 * Firebaseエミュレータを利用するか否かを判定します。
 *
 *  - 単体テスト実行時 (NODE_ENV="test") にはエミュレータを利用します。
 *  - webpack-dev-server による開発時 (NODE_ENV="development") には、 WITH_CLOUD_BACKEND が "false" のときに、エミュレータを利用します。
 *     - WITH_CLOUD_BACKEND が "true" のときには、エミュレータを利用せず、 Google Cloud のデータベース、認証サービス等を利用します。
 *
 * @returns エミュレータ利用時に true を返す
 */
export const emulatorEnabled = (): boolean => {
  const NODE_ENV = process.env.NODE_ENV;
  const WITH_CLOUD_BACKEND = process.env.WITH_CLOUD_BACKEND;

  return NODE_ENV === 'test' || (NODE_ENV === 'development' && WITH_CLOUD_BACKEND === 'false');
};

const FIREBASE_DATABASE_EMULATOR_HOST = 'localhost:9094';
const FIREBASE_AUTHENTICATION_EMULATOR_URL = 'http://localhost:9096';
export const FIREBASE_FUNCTIONS_EMULATOR_HOST = 'localhost:9097';
export const FIREBASE_EMULATOR_UI_URL = 'http://localhost:9095/database/levii-balus-local/data';
const FIREBASE_STORAGE_EMULATOR_HOST = 'localhost:9099';

export const setupFirebaseEmulator = () => {
  // auth
  firebase.app().auth().useEmulator(FIREBASE_AUTHENTICATION_EMULATOR_URL);

  // database: デフォルトRTDBと、行動イベントログ記録用RTDBについて、エミュレータ接続設定を適用する
  const [databaseHost, databasePort] = FIREBASE_DATABASE_EMULATOR_HOST.split(':', 2);
  firebase.app().database().useEmulator(databaseHost, Number(databasePort));

  // functions
  const [functionsHost, functionsPort] = FIREBASE_FUNCTIONS_EMULATOR_HOST.split(':', 2);
  firebase.app().functions().useEmulator(functionsHost, Number(functionsPort));

  // storage
  const [storageHost, storagePort] = FIREBASE_STORAGE_EMULATOR_HOST.split(':', 2);
  firebase.app().storage().useEmulator(storageHost, Number(storagePort));
};
